// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1bcuE","form":"styles_form__2r_tI"};